import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Button } from '../UiKit/Button';
import { Icon } from '../UiKit/Icon';
import { PopoverH } from '../UiKit/TooltipH';
import { withPentaMemberOrder } from '../utilsPenta';

export const PentaMemberActions = ({
  penta = {},
  avatar = {},
  disabled,
  style = {},
  callback = () => void (0),
  buttonProps = {}
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const [open, setOpen] = useState(false);

  const member = (penta.members || []).find((one) => one.avatar?.token === avatar?.token);
  const memberIndex = (penta.members || []).findIndex((one) => one.avatar?.token === avatar?.token);
  const canReorder = Boolean(context.me && (penta.members?.length || 0) > 1 && memberIndex >= 0);
  const canMoveLeft = canReorder && memberIndex > 0;
  const canMoveRight = canReorder && memberIndex < penta.members.length - 1;

  const closeMenu = () => setOpen(false);

  const openMember = () => {
    const token = member?.user?.token || avatar?.token;
    if (!token) return;
    closeMenu();
    const base = location.pathname.startsWith('/yoni') ? '/yoni' : '/u';
    navigate(`${base}/${token}`);
  };

  const deleteFromPenta = () => {
    closeMenu();
    context.x.deleteFromPenta(penta.token, avatar.token, callback);
  };

  const moveBy = (delta) => {
    const toIndex = memberIndex + delta;
    if (!canReorder || toIndex < 0 || toIndex >= penta.members.length) return;

    const members = [...penta.members];
    const [moved] = members.splice(memberIndex, 1);
    members.splice(toIndex, 0, moved);
    const reordered = withPentaMemberOrder(penta, members);
    closeMenu();
    callback(reordered);

    if (penta.my !== false && penta.token) {
      context.x.updatePenta({
        token: reordered.token,
        description: reordered.description,
        members: reordered.members,
      });
    }
  };

  const menu = (
    <div className="_fv _fgap05" onClick={(e) => e.stopPropagation()}>

      {canReorder && (
        <div className="_f _f100">
          <Button
            className="x_penta_member_leftright _fgrow"
            sm
            ghost
            disabled={disabled || !canMoveLeft}
            onClick={disabled || !canMoveLeft ? void (0) : () => moveBy(-1)}
            icon="keyboard_arrow_left"
          />
          <Button
            sm
            className="x_penta_member_leftright _fgrow"
            ghost
            disabled={disabled || !canMoveRight}
            onClick={disabled || !canMoveRight ? void (0) : () => moveBy(1)}
            icon="keyboard_arrow_right"
          />
        </div>
      )}

      <div className="_f">
        <Button
          disabled={disabled}
          ghost
          className="_fgrow"
          icon="person"
          onClick={disabled ? void (0) : openMember}
        >
          {$ui('penta_open')}
        </Button>

        <Button
          disabled={disabled}
          red
          onClick={disabled ? void (0) : deleteFromPenta}
          icon="delete"
        >
        </Button>
      </div>

    </div>
  );

  return (
    <div className="x_choose_one_menu0 x_penta_member_actions" style={style}>
      <PopoverH
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        placement="bottomRight"
        arrow={false}
        title={menu}
      >
        <div className="x_choose_one_menu_ico">
          <Icon size={20} icon="more_vert" {...buttonProps} />
        </div>
      </PopoverH>
    </div>
  );
};
